jQuery(document).ready(function($) {

    handle_search_click = function (data) {

        $.ajax({
            url: '/wp-json/chapmans/product-search/',
            type: 'get',
            data: {
                keyword: data.slug,
                type: data.taxonomy
            },
            beforeSend: function () {
                $('#ProductResults').removeClass('open');
                $('#Loading').show();
                $('#ProductListing').css('opacity', 1);
            },
            success: function (data) {
    
                $('#Loading').hide();
                $('#ProductResults').addClass('open');
    
                if ($('#ProductFinder').data('preselect') == '') {
                    $('html, body').animate({
                        scrollTop: $("#ProductListing").offset().top - 50
                    }, 700);
                }
    
                populate_search_results(data);
    
            },
            error: function (error) {
                console.log(error);
            }
    
        });
    
    };

    function autocomplete(input, arr, storeSearch) {

        /*the autocomplete function takes two arguments,
        the text field element and an array of possible autocompleted values:*/
        var currentFocus;

        /*execute a function when someone writes in the text field:*/
        input.addEventListener("input", function(e) {
            var a, b, i, val = this.value;

            /*close any already open lists of autocompleted values*/
            closeAllLists();

            if (!val) {
                return false;
            }

            currentFocus = -1;

            /*create a DIV element that will contain the items (values):*/
            a = document.createElement("DIV");
            a.setAttribute("id", this.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");

            /*append the DIV element as a child of the autocomplete container:*/
            this.parentNode.appendChild(a);

            /*for each item in the array...*/
            for (i = 0; i < arr.length; i++) {

                let match = '';
                let tail = '';
                let name = '';

                /*check if the item starts with the same letters as the text field value:*/
                if (arr[i] instanceof Object) {
                    // maybe this match can do some inner looks? hmm perhaps.
                    if (arr[i].name.substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                        match = arr[i].name.substr(0, val.length);
                        tail = arr[i].name.substr(val.length);
                        name = arr[i].name;
                    }
                } else {
                    if (arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                        match = arr[i].substr(0, val.length);
                        tail = arr[i].substr(val.length);
                        name = match + tail;
                    }
                }

                if (match) {

                    /*create a DIV element for each matching element:*/
                    b = document.createElement("div");

                    /*make the matching letters bold:*/
                    b.innerHTML = "<strong>" + match + "</strong>";
                    b.innerHTML += tail;

                    /*insert a input field that will hold the current array item's value:*/
                    b.innerHTML += "<input type='hidden' value='" + name + "'>";

                    $(b).find('input').data('search', arr[i]);

                    /*execute a function when someone clicks on the item value (DIV element):*/
                    b.addEventListener("click", function(e) {

                        /*insert the value for the autocomplete text field:*/
                        input.value = this.getElementsByTagName("input")[0].value;

                        // "this" is the div with a hidden input element... strange.
                        let data = $(this).find('input').data('search');

                        if (data && storeSearch) {

                            fetch_autocomplete();

                            // if (data.taxonomy) {
                            //     // other taxonomies will return groups via ajax calls to show the mini picker.
                            //     handle_search_click(data);
                            // } else {
                            //     fetch_autocomplete();
                            // }

                        } else {
                            // submit
                            $(input).closest('form').submit();
                        }

                        /*close the list of autocompleted values,
                        (or any other open lists of autocompleted values:*/
                        closeAllLists();
                    });

                    a.appendChild(b);
                }

            }
        });

        /*execute a function presses a key on the keyboard:*/
        input.addEventListener("keydown", function(e) {

            var x = document.getElementById(this.id + "autocomplete-list");
            if (x) x = x.getElementsByTagName("DIV");

            if (e.keyCode == 40) {
                /*If the arrow DOWN key is pressed,
                increase the currentFocus variable:*/
                currentFocus++;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode == 38) { //up
                /*If the arrow UP key is pressed,
                decrease the currentFocus variable:*/
                currentFocus--;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode == 13) {

                // form submission handled in click event
                if (currentFocus > -1) {
                    e.preventDefault();

                    /*and simulate a click on the "active" item:*/
                    if (x) x[currentFocus].click();
                }
            }
        });

        function addActive(x) {
            /*a function to classify an item as "active":*/
            if (!x) return false;

            /*start by removing the "active" class on all items:*/
            removeActive(x);
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (x.length - 1);

            /*add class "autocomplete-active":*/
            x[currentFocus].classList.add("autocomplete-active");
        }

        function removeActive(x) {
            /*a function to remove the "active" class from all autocomplete items:*/
            for (var i = 0; i < x.length; i++) {
                x[i].classList.remove("autocomplete-active");
            }
        }

        function closeAllLists(e) {
            /*close all autocomplete lists in the document,
            except the one passed as an argument:*/
            var x = document.getElementsByClassName("autocomplete-items");
            for (var i = 0; i < x.length; i++) {
                if (e != x[i] && e != input) {
                    x[i].parentNode.removeChild(x[i]);
                }
            }
        }

        /*execute a function when someone clicks in the document:*/
        document.addEventListener("click", function (e) {
            closeAllLists(e.target);
        });
    }

    // Search Page
    if(document.getElementsByClassName("search-page").length > 0) {
        $.getJSON(php_vars.json, function(json) {
            autocomplete(document.getElementsByClassName("search-page")[0], json, false);
        });
    }

    // Global Search
    if(document.getElementsByClassName("main-search").length > 0) {
        $.getJSON(php_vars.json, function(json) {
            autocomplete(document.getElementsByClassName("main-search")[0], json, false);
        });
    }

    // Product Finder
    if(document.getElementById("ProductSearch")) {
        autocomplete(document.getElementById("ProductSearch"), lookup_values, true);
    }

});
